import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { getTaxReceiptConfigurationLogs } from '../../taxReceiptActions';

import HistoryTable from 'Parts/common/HistoryTable';

const mapStateToProps = state => ({
  logs: state.TaxReceipt.taxReceiptConfigurationLogs || {results: []},
});

const mapDispatchToProps = dispatch => bindActionCreators({
  loadLogs: getTaxReceiptConfigurationLogs
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(HistoryTable);
